<template>
  <section class="chat-list-box" ref="wrapper">
    <ul class="chat-lists" :class="{ 'show-date-time': showDateTime }">
      <li
        class="chat-list"
        :id="item.id"
        v-for="(item, index) in chatControl.chatModel.infos"
        :key="index"
      >
        <chat-connect
          v-if="
            item.type.search('CONNECTING') > -1 ||
            item.type.search('LOADING') > -1
          "
          :item="item"
          :chat-model="chatControl.chatModel"
        />
        
        <v-touch v-else @press="handlePress(item)">
          <div class="chat-info" :class="getClassName(item.type)">
            <div class="arrow"></div>

            <chat-audio v-if="item.type.search('AUDIO') > -1" :item="item" />

            <div
              class="info-content-wrapper"
              v-else-if="item.title"
            >
              <div
                class="info-box"
                v-html="chatControl.chatModel.escape(item.title)"
                @click="handleConnect($event, item)"
              ></div>

              <div class="confirm-button-box" v-if="item.confirmButton && item.confirmButton.show">
                <button
                  class="confirm-btn"
                  :class="{ confirmed: item.confirmButton.confirmed }"
                  @click="handleConfirm(item)"
                  :disabled="item.confirmButton.confirmed"
                >
                  {{ item.confirmButton.confirmed ? '已确认' : '确认信息' }}
                </button>
              </div>
            </div>

            <div class="suggestion-box" v-if="item.suggestions">
              <chat-context
                v-if="item.content"
                :chat-model="chatControl.chatModel"
                :item="item"
                @content-tap="handleConnect($event, item)"
              />
              <div
                class="sug-item"
                v-for="row in item.suggestions"
                :key="row.id"
                @click="chatControl.addInfoArticleById(item.suggestions, row)"
              >
                <img class="icon" src="@/assets/image/question@3x.png" />
                <span class="text">{{ row.title }}</span>
              </div>
            </div>

            <div class="assess-box" v-if="item.assess">
              <div
                class="assess-item"
                :class="{ active: row.checked }"
                v-for="row in item.assess"
                :key="row.key"
                @click="chatControl.setInfoStatusByArticle(item, row)"
              >
                <img
                  class="icon"
                  :src="
                    require(`@/assets/image/${row.key}${
                      row.checked ? '' : '_hover'
                    }@3x.png`)
                  "
                />
                <span class="text">{{ row.name }}</span>
              </div>
            </div>
          </div>

          <div class="chat-bottom" :class="getClassName(item.type)">
            <span
              class="read-status"
              :class="{ unread: item.unread }"
              v-if="hasReadStatus(item)"
              >{{ item.unread ? '未读' : '已读' }}
            </span>
            <span class="chat-time" v-if="hasDateTime(item)">
              {{ item.time }}
            </span>
          </div>
        </v-touch>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import chatConnect from './chatConnect'
import chatContext from './chatContext'
import chatAudio from './chatAudio'
import * as Utils from '@/assets/script/utils'

export default {
  data() {
    return {
      showDateTime: false,
    }
  },
  computed: {
    ...mapState(['chatControl']),
  },
  methods: {
    getClassName(type) {
      return type.toLowerCase().replace(/,\s*/g, ' ')
    },

    hasReadStatus(item) {
      const isExist = typeof item.unread !== 'undefined',
        isArtificial = Utils.checkType('SEND & ARTIFICIAL', item.type)
      return isExist && isArtificial
    },

    handleConnect: Utils.thorttle(function (e, item) {
      const type = e.target.getAttribute('type')
      const hasConnected = () => {
        console.log('🔍 [ChatList] hasConnected检查开始')
        console.log('🔍 [ChatList] 当前连接状态:', {
          connected: this.chatControl.connected,
          isLoading: this.chatControl.isLoading
        })
        
        if (this.chatControl.connected) {
          console.log('❌ [ChatList] 已经连接客服，阻止重复连接')
          this.$createToast({
            txt: '人工客服已连接',
            type: 'warn',
          }).show()
          return false
        }
        if (this.chatControl.isLoading) {
          console.log('❌ [ChatList] 正在排队中，阻止重复连接')
          this.$createToast({
            txt: '正在排队中',
            type: 'warn',
          }).show()
          return false
        }
        console.log('✅ [ChatList] 连接检查通过')
        return true
      }

      switch (type) {
        case 'connect':
          console.log('🔍 [ChatList] 用户点击连接客服按钮')
          if (hasConnected()) {
            console.log('🔍 [ChatList] 检查通过，开始初始化WebSocket')
            this.chatControl.initWebSocket()
          } else {
            console.log('❌ [ChatList] 连接检查失败，hasConnected()返回false')
          }
          break

        case 'reconnect':
          if (hasConnected()) {
            this.chatControl.reconnectSocket()
          }
          break

        case 'image':
          let index = null,
            imgs = this.chatControl.chatModel.getInfosByImg()

          for (let i = 0; i < imgs.length; i++) {
            if (imgs[i].id === item.id) index = i
          }
          const currentImg = imgs[index].url
          this.$createImagePreview({
            // initialIndex: index,
            imgs: [currentImg],
          }).show()
          break
      }
    }, 0),

    handlePress(info) {
      if (Utils.checkType('SYSTEM', info.type)) return
      const data = [
        {
          key: 'copy',
          content: '复制',
        },
        {
          key: 'delete',
          content: '删除',
        },
        {
          key: 'time',
          content: this.showDateTime ? '收起时间' : '查看时间',
        },
      ]

      if (Utils.checkType('IMAGE | ARTICLE | SYSTEM', info.type)) {
        data.splice(0, 1)
      }
      if (Utils.checkType('DATE_TIME', info.type)) {
        data.splice(1, 1)
      }
      if (this.chatControl.showWithdraw(info)) {
        data.splice(1, 0, {
          key: 'withdraw',
          content: '撤回',
        })
      }

      this.$createActionSheet({
        data,
        onSelect: (item, index) => {
          switch (item.key) {
            case 'copy':
              Utils.copyContent(info.title.replace(/<[^<>]+>/g, ''))
              this.$createToast({
                txt: `复制成功`,
                type: 'correct',
              }).show()
              break
            case 'delete':
              this.chatControl.chatModel.remove(info.id)
              break
            case 'withdraw':
              this.chatControl.withdrawInfo(info)
              break
            case 'time':
              this.showDateTime = !this.showDateTime
              break
          }
        },
      }).show()
    },

    hasDateTime(item) {
      return this.showDateTime && !Utils.checkType('SYSTEM', item.type)
    },

    async handleConfirm(item) {
      if (item.confirmButton.confirmed) return

      try {
        // 解析消息内容
        const feedbackData = Utils.parseFeedbackMessage(item.title)
        console.log('📋 [ChatList] 解析的反馈数据:', feedbackData)

        // 调用控制器提交反馈
        const result = await this.chatControl.submitFeedback(feedbackData)
        console.log('✅ [ChatList] 后端返回结果:', result)

        // 更新确认状态
        item.confirmButton.confirmed = true

        // 显示成功提示
        this.$createToast({
          txt: '提交成功，您的问题已经记录，稍后会有工作人员与您联系。感谢您的耐心等待！',
          type: 'correct',
          $class: 'cube-toast--correct',
          time: 3000
        }).show()
      } catch (error) {
        console.error('❌ [ChatList] 确认信息失败:', error)
        const errorMessage = (error && error.msg) || (error && error.message) || '确认失败，请重试'
        this.$createToast({
          txt: errorMessage,
          type: 'error',
          time: 2000
        }).show()
      }
    },
  },

  components: {
    chatConnect,
    chatContext,
    chatAudio
  },
}
</script>

<style lang="stylus">
.chat-list-box {
  .chat-list {
    position: relative;
    margin-bottom: 25px;

    &:after {
      content: '.';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }

    .chat-info {
      display: inline-block;
      position: relative;
      padding: 10px 15px;
      border-radius: 10px;

      .info-box {
        h1, h2, h3, h4, h5, h6 {
          margin: 8px 0;
          font-weight: bolder;
          line-height: 1.4;
        }

        h1 {
          font-size: 1.25rem;
        }

        h2 {
          font-size: 1.18rem;
        }

        h3 {
          font-size: 1.1rem;
        }

        h4, h5, h6 {
          font-size: 1rem;
        }

        strong, b {
          font-weight: bolder;
        }

        .blue {
          color: #193a79;
          font-weight: bolder;
          margin: 0 2px;
        }

        ol, ul {
          margin: 8px 0;
          padding-left: 20px;
        }

        li + li {
          margin-top: 4px;
        }

        .photo {
          display: block;
          width: 100%;
          height: auto;
          border-radius: 7px;
        }

        .face {
          display: inline-block;
          margin: 0 1px -5px;
          width: 21px;
          height: 21px;
        }
      }

      .info-content-wrapper {
        display: flex;
        align-items: center;
        gap: 8px;

        .info-box {
          flex: 1;
          min-width: 0;
        }

        .confirm-button-box {
          flex-shrink: 0;

          .confirm-btn {
            padding: 8px 14px;
            border: none;
            border-radius: 5px;
            font-size: 14px;
            cursor: pointer;
            white-space: nowrap;
            transition: all 0.3s;
            -webkit-tap-highlight-color: transparent;
            touch-action: manipulation;
            min-height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:not(.confirmed) {
              background: #193a79;
              color: #fff;

              &:active {
                opacity: 0.8;
                transform: scale(0.98);
              }
            }

            &.confirmed {
              background: #e8e7e7;
              color: #999;
              cursor: not-allowed;
            }
          }
        }
      }

      .arrow {
        position: absolute;
        width: 0;
        height: 0;
        top: 50%;
        margin-top: -6px;
      }

      &.send {
        float: right;
        color: #fff;
        background: #193a79;

        .arrow {
          right: -6px;
          border-top: 6px solid transparent;
          border-left: 6px solid #193a79;
          border-bottom: 6px solid transparent;
        }

        .link {
          color: #fff;
          text-decoration: underline;
        }
      }

      &.receive {
        float: left;
        background: #fff;

        .arrow {
          left: -6px;
          border-top: 6px solid transparent;
          border-right: 6px solid #fff;
          border-bottom: 6px solid transparent;
        }

        .link {
          color: #193a79;
          text-decoration: underline;
        }
      }

      &.send, &.receive {
        &:active {
          opacity: 0.7;
        }
      }

      &.system {
        width: 100%;
        padding: 0;
        text-align: center;

        .info-box {
          display: inline-block;
          font-size: 0.8rem;
          background: #e8e7e7;
          padding: 2px 8px;
          border-radius: 5px;
        }
      }

      &.article {
        width: 100%;
        box-sizing: border-box;

        .info-box {
          font-weight: bolder;
          padding-top: 5px;
        }

        .photo {
          width: 100%;
          height: auto;
        }
      }

      &.image {
        padding: 0;
        width: 36%;
      }

      .suggestion-box {
        margin-top: 10px;

        .chat-context {
          margin-bottom: 15px;
        }

        .sug-item {
          display: flex;
          padding: 8px 0;
          border-top: 1px dashed #d0d0d0;

          .icon {
            display: inline-block;
            width: 15px;
            height: 15px;
            margin-right: 5px;
            position: relative;
            top: 3px;
          }

          .text {
            display: inline-block;
          }
        }
      }

      .assess-box {
        display: flex;
        padding-top: 10px;
        margin: 12px 0 2px;
        border-top: 1px solid #eee;

        .assess-item {
          flex: 1;
          text-align: center;
          color: #999;

          &:last-child {
            border-left: 1px solid #e2e0e0;
          }

          &.active {
            color: #193a79;
          }

          .icon {
            position: relative;
            width: 15px;
            margin-right: 2px;
          }

          .text {
            font-size: 1rem;
          }

          &:nth-child(1) {
            .icon {
              top: 1px;
            }
          }

          &:nth-child(2) {
            .icon {
              top: 4.5px;
            }
          }
        }
      }
    }

    .chat-bottom {
      position: absolute;
      bottom: -19px;
      font-size: 13px;
      color: #666;
      overflow: hidden;

      &.receive {
        left: 0;
        margin-left: 5px;

        .read-status {
          float: left;
          margin-right: 5px;
        }

        .chat-time {
          float: left;
        }
      }

      &.send {
        right: 0;
        margin-right: 5px;

        .read-status {
          float: right;
          margin-left: 5px;
        }

        .chat-time {
          float: right;
        }
      }

      .read-status {
        &.unread {
          color: #193a79;
        }
      }
    }
  }
}

.cube-toast {
  .cube-toast-icon {
    width: 22px;
    height: 22px;
    font-size: 22px;
    margin-top: -12px;
  }

  .cube-toast-tip {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/chatList.vue